import { Viajes } from "../../components";
import "../CategoriaVacaciones/stylesCategoriaVacaciones.scss";

export const CategoriaViajes = () => (
  <div>
    <Viajes />
  </div>
);

export default CategoriaViajes;
